import { AnnouncementsList } from '~/features/announcements/announcements-list'
import { EAnnouncementType } from '~/features/announcements/types'
import { CENTER_MIDDLE_TITLE } from '~/features/center/constants'

export const CenterFmAnnouncements = () => (
  <AnnouncementsList
    detailPageBaseRoute="/user/center/announcement"
    tagId={EAnnouncementType.LiveLiverTag}
    documentTitle={['公告', CENTER_MIDDLE_TITLE]}
    pageTitle="直播公告"
  />
)
